"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = __importStar(require("react"));
function UndrawBuyHouse(p) {
  var primaryColor = p.primaryColor,
    height = p.height,
    style = p.style,
    props = __rest(p, ["primaryColor", "height", "style"]);
  var styleProps = __assign({
    width: '100%',
    height: height
  }, style);
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1137 531.168",
    style: styleProps
  }, props), React.createElement("path", {
    d: "M125.898 528.556l-1.951-.44c21.756-96.75 76.43-184.609 153.951-247.391a444.114 444.114 0 01712.155 246.21l-1.95.444C942.05 325.17 764.83 183.945 557.135 183.945c-204.974 0-386.334 144.93-431.236 344.61z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    fill: "#a0616a",
    d: "M1051.5 482.5l3 22-21 2 3-27 15 3zM952.5 180.5s2 27 2 28-14 70-14 70-20 38 0 37 14-36 14-36l21-58-9-41zM985.5 482.5l-3 22 21 2-3-27-15 3z"
  }), React.createElement("path", {
    d: "M962.5 276.5l-5 7s-3 30 0 40 9 56 9 59 1 5 0 6-4 1-2 3 2 8 2 8v5l13 74s-8 9-2 9 28 0 27-10l-2-1s-3-66-2-69 0-9 0-9-2-3 0-4 2-9 2-9l9-61s8 41 13 45 4 14 4 14l4 88s-4 10 0 12 21 9 22-1 6-97 6-101-1-6 0-9-1-3 0-3-2-3-2-5v-49s1-10 2-12-1-4 0-7-2-13-2-13l-45-12zM997.5 500.5s5-5-2-5a32.55 32.55 0 00-13 3l-5 18S957 533 980 531s19.5-.5 19.5-.5 7-2 8-4-2-31-2-31-3 8-8 5zM1040.5 500.5s-5-5 2-5a32.55 32.55 0 0113 3l5 18S1081 533 1058 531s-22.5-.5-22.5-.5-7-2-8-4 5-31 5-31 3 8 8 5z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M286.141 177.432h8.903v351.653h-8.903z"
  }), React.createElement("path", {
    d: "M377.205 222.246c.566 122.964-85.946 223.048-85.946 223.048s-87.43-99.282-87.997-222.246S289.207 0 289.207 0s87.431 99.282 87.998 222.246z",
    fill: primaryColor
  }), React.createElement("path", {
    fill: "#f2f2f2",
    d: "M225.5 383.5h689v146h-689z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M203.5 399.5l75-157h599l56 157h-730z"
  }), React.createElement("path", {
    fill: "#f2f2f2",
    d: "M390.5 252.5h278v92h-278z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M408.5 177.5l-44 92h330l-26-92h-260z"
  }), React.createElement("path", {
    fill: "#ccc",
    d: "M415 412.5h219.5v117H415zM252.5 416.5h117v113h-117z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M672.5 423.5H733v106h-60.5z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M0 529h1137v2H0z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M179.905 297.059h5.875v232.053h-5.875z"
  }), React.createElement("path", {
    d: "M239.997 326.631c.374 81.144-56.714 147.188-56.714 147.188s-57.695-65.515-58.07-146.659 56.715-147.187 56.715-147.187 57.695 65.515 58.07 146.658z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M239.997 326.631c.374 81.144-56.714 147.188-56.714 147.188s-57.695-65.515-58.07-146.659 56.715-147.187 56.715-147.187 57.695 65.515 58.07 146.658z",
    opacity: 0.1
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M103.533 297.059h5.875v232.053h-5.875z"
  }), React.createElement("path", {
    d: "M163.625 326.631C164 407.775 106.91 473.82 106.91 473.82S49.215 408.304 48.842 327.16s56.714-147.187 56.714-147.187 57.695 65.515 58.07 146.658z",
    fill: primaryColor
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M798.5 429.5H828V457h-29.5zM838 429.5h29.5V457H838zM798.5 467H828v28.5h-29.5zM838 467h29.5v28.5H838zM416 277.674h23.087v21.522H416zM446.913 277.674H470v21.522h-23.087zM416 307.022h23.087v22.304H416zM446.913 307.022H470v22.304h-23.087zM589 277.674h23.087v21.522H589zM619.913 277.674H643v21.522h-23.087zM589 307.022h23.087v22.304H589zM619.913 307.022H643v22.304h-23.087zM503 277.674h23.087v21.522H503zM533.913 277.674H557v21.522h-23.087zM503 307.022h23.087v22.304H503zM533.913 307.022H557v22.304h-23.087z"
  }), React.createElement("path", {
    fill: "#f2f2f2",
    d: "M686 434.239h14.536v13.551H686zM705.464 434.239H720v13.551h-14.536zM686 452.717h14.536v14.043H686zM705.464 452.717H720v14.043h-14.536z"
  }), React.createElement("circle", {
    cx: 725,
    cy: 484,
    r: 4,
    fill: "#f2f2f2"
  }), React.createElement("path", {
    fill: "#f2f2f2",
    d: "M415 425h220v2H415zM415 434h220v2H415zM415 443h220v2H415zM415 452h220v2H415zM415 461h220v2H415zM415 470h220v2H415zM415 479h220v2H415zM415 488h220v2H415zM415 497h220v2H415zM415 506h220v2H415zM415 515h220v2H415zM252.5 425h117v2h-117zM252.5 434h117v2h-117zM252.5 443h117v2h-117zM252.5 452h117v2h-117zM252.5 461h117v2h-117zM252.5 470h117v2h-117zM252.5 479h117v2h-117zM252.5 488h117v2h-117zM252.5 497h117v2h-117zM252.5 506h117v2h-117zM252.5 515h117v2h-117z"
  }), React.createElement("circle", {
    cx: 877,
    cy: 242,
    r: 81,
    fill: primaryColor
  }), React.createElement("path", {
    fill: "#fff",
    d: "M928 234h-43v-43h-16v43h-43v16h43v43h16v-43h43v-16z"
  }), React.createElement("circle", {
    cx: 975.5,
    cy: 75.5,
    r: 26,
    fill: "#a0616a"
  }), React.createElement("path", {
    d: "M966.5 94.5s4 20 4 23 17 12 17 12l19-24s-12-17-12-21z",
    fill: "#a0616a"
  }), React.createElement("path", {
    d: "M981.5 120.5s-8.716-2.32-11.358-6.16c0 0-27.642 27.16-27.642 32.16l22 39s0 14 2 15 0 0 0 4-6 30-4 34 4 1 2 7-7 38-7 38 18-6 44 4 57-4 57-4-8-18-6-24-5-17-5-17l-5-92s7-41 2-43l-10-4-32.024-3.936S994.5 119.5 981.5 120.5z",
    fill: "#d0cde1"
  }), React.createElement("path", {
    d: "M952.5 139.5l-10 7s-5 15 0 22 7 17 7 17l20-2z",
    fill: "#d0cde1"
  }), React.createElement("path", {
    d: "M1026.5 148.5s-5.79 14.89-4.581 29.624a15.614 15.614 0 002.581 7.376l-70.944 33.681S921.5 222.5 929.5 236.5s37-7 37-7 76-11 82-22 10-57 10-57z",
    fill: "#a0616a"
  }), React.createElement("path", {
    d: "M955.65 48.022l-4.51-1.805s9.43-10.382 22.55-9.48L970 32.676s9.02-3.61 17.22 5.868c4.31 4.983 9.297 10.84 12.406 17.438h4.83l-2.016 4.44 7.056 4.438-7.242-.798a24.561 24.561 0 01-.685 11.496l.194 3.508s-8.394-12.987-8.394-14.793v4.514s-4.51-4.062-4.51-6.77l-2.46 3.16-1.23-4.966L970 65.175l2.46-4.062-9.43 1.354 3.69-4.965s-10.66 5.868-11.07 10.833-5.74 11.285-5.74 11.285l-2.46-4.514s-3.69-20.313 8.2-27.084z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    d: "M1029.5 107.5h15s11 2 14 22 6 25 3 25-39-1-39-2 7-45 7-45z",
    fill: "#d0cde1"
  }));
}
exports.default = UndrawBuyHouse;